var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnalyse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_55117_7134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.3889 9.81312C19.3888 11.513 18.9106 13.1786 18.0089 14.6196C17.1072 16.0606 15.8185 17.219 14.2898 17.9625C12.7612 18.706 11.0542 19.0046 9.36394 18.8241C7.67367 18.6437 6.06821 17.9915 4.73093 16.9421M1.29993 10.6311C1.13215 8.78582 1.53406 6.93343 2.45151 5.32359C3.36896 3.71376 4.75785 2.42385 6.431 1.6277C8.10416 0.83155 9.98115 0.567431 11.809 0.870935C13.6369 1.17444 15.3279 2.03098 16.6539 3.32512M16.7349 16.2211L23.7499 23.2501M23.7499 6.32112V1.50012H18.9429",
    stroke: "#002E6E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.25 16.5L9.57 8.183C9.74797 8.00621 9.98865 7.907 10.2395 7.907C10.4904 7.907 10.731 8.00621 10.909 8.183L13.355 10.63C13.5326 10.8075 13.7734 10.9072 14.0245 10.9072C14.2756 10.9072 14.5164 10.8075 14.694 10.63L23.75 1.5",
    stroke: "#002E6E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_55117_7134"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyse);
export default __webpack_public_path__ + "static/media/analyse.c568253f4088025b5f6036d2632f584c.svg";
export { ForwardRef as ReactComponent };